cockpitApp.directive('checkoutBottomBar', function () {
  return {
    restrict: 'E',
    replace: true,
    templateUrl: '/element/detail/checkout-bottom-bar',
    controllerAs: 'checkoutBottomBarCtrl',
    controller: 'checkoutBottomBarController'
  };
});
